import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Box, Paper } from "@mui/material";
import styles from "./styles";
import { useAppSelector } from "../../../redux/store";
import SafetyBox from "../SafetyBox";

interface Props {
  examDetails: any;
  variant?: "green" | "grey";
}

const OrderCard = ({ examDetails, variant = "green" }: Props) => {
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const { pageText } = customerJourney;

  const getDate = (data: string) => {
    const date = new Date(data);
    return `${date.getDate() <= 9 ? "0" + date.getDate() : date.getDate()}/${
      date.getMonth() <= 8 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1
    }/${date.getFullYear()}`;
  };
  return (
    <Paper
      id="order_card"
      className={variant}
      component={Box}
      sx={styles.detailCard}
    >
      <Box className="head">{pageText?.textMetadata?.orderdetails}:</Box>
      <Box className="sub_head">{examDetails?.examName}</Box>
      <Box className="detail_box">
        <Box className="detail_row">
          <Box className="left">{pageText?.textMetadata?.dateonly}:</Box>
          <Box className="right today">
            <CalendarTodayIcon />
            {getDate(examDetails?.examDate)}
          </Box>
        </Box>
        {examDetails?.speakingTestDate && (
          <Box className="detail_row">
            <Box className="left">
              {pageText?.labelsMetadata?.speakingTestDateLabel}:
            </Box>
            <Box className="right month">
              <CalendarMonthIcon />
              {examDetails?.speakingTestDate}
            </Box>
          </Box>
        )}
        <Box className="detail_row">
          <Box className="left">{pageText?.textMetadata?.format}:</Box>
          <Box className="right">{examDetails?.examFormat}</Box>
        </Box>
        <Box className="detail_row">
          <Box className="left">{pageText?.textMetadata?.availability}:</Box>
          <Box className={`right status ${examDetails?.availability}`}>
            <Box className="dot"></Box> {examDetails?.availability}
          </Box>
        </Box>
      </Box>
      <Box className="card_seperator"></Box>
      <Box className="price_field">
        <Box className="left_text">{pageText?.textMetadata?.price}:</Box>
        <Box className="right_text">{examDetails?.priceString}</Box>
      </Box>
      <SafetyBox />
    </Paper>
  );
};

export default OrderCard;
